// Import Packages
import React, { useState, useRef, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDrag } from "react-dnd";

// Import MaterialUI
import MoreVertIcon from "@material-ui/icons/MoreVert";
import { Button, CircularProgress, IconButton } from "@material-ui/core";
import { KeyboardArrowUp, KeyboardArrowDown } from '@material-ui/icons'

// Import Services

// Import Recoil
import { operationLogsStatus } from "../../recoil-store/recoil-state";
import { useRecoilState } from "recoil";

// Import Icons
import emptyPageIcon from "../../assets/icons/configurationIcons/empty-page.svg";


// Import CSS
import "./NewAccordion.css";
import Pagination from "../Pagination/Pagination";


function NewAccordion({ data, customColumns, customItemColumns, isAccordion, isChildItems, index, quickAddCredential, gridColumns, showType, refresh,
    handleDragStart, selectedItems, setSelectedItems, infoIcon, visibility, dragAvailable, label, customLabel, fetchChildItems, fetchParentItems, titleClass, from, childGridColumns,
    stopFetch, trigger }) {
    const { t } = useTranslation();
    const [expand, setExpand] = useState(false);
    const [logsStatus, setLogsStatus] = useRecoilState(operationLogsStatus);
    const [childItems, setChildItems] = useState({});
    const [triggerFetch, setTriggerFetch] = useState(false);
    const [loading, setLoading] = useState(false);
    const [firstTimeRender, setFirstTimeRender] = useState(true);
    const [{ opacity }, drag, preview] = useDrag({
        item: {
            automGroupId: data?.autom_group_id,
            id: data ? data.id : "", type: 'draggableItem'
        },
        collect: (monitor) => ({
            opacity: monitor.isDragging() ? 0 : 1,
        }),
    });

    useEffect(() => {
        setFirstTimeRender(false)
    }, []);

    useEffect(() => {
        if (from && showType && showType === "longQueue" && index === 0 && data?.operation_count) {
            setExpand(true)
        }
    }, [from])

    useEffect(() => {
        if (!isChildItems && showType && index === refresh?.index && expand && !firstTimeRender) {
            setTriggerFetch((pre) => !pre)
            // callFetch(0, 10, true);
        }
        else if (!isChildItems && showType && index === refresh?.index && !expand && !firstTimeRender) {
            callFetch(0, 10, true);
        }
    }, [refresh])

    useEffect(() => {
        if (logsStatus.operation_id && showType !== "singleView" && childItems?.data) {
            let copyData = [...childItems.data];
            const operation_id = logsStatus.operation_id;

            const i = copyData.findIndex(x => x.operation_id === operation_id);
            if (i !== -1 && logsStatus.status !== copyData[i].logs_status) {
                copyData[i].logs_status = logsStatus.status;
                setChildItems((pre) => { return { ...pre, data: copyData } });
            }
        }
    }, [logsStatus])

    const callFetch = async (startIndex, itemsPerPage, fromRefresh) => {
        setLoading(true)
        const res = await fetchChildItems(data, startIndex, itemsPerPage, fromRefresh)
        setLoading(false)
        if (res) {
            setChildItems(res)
        }
    };

    return (
        <>
            <div ref={preview}
                style={{ opacity: opacity }}
                onDragStart={(e) => {
                    if (handleDragStart) {
                        handleDragStart(e, data.id)
                    }
                }}
                className={!isChildItems ? `accordion-item-container ${expand ? "active" : ""}
                 ${!isChildItems && childItems?.data?.length && showType && expand ? "pagination-added" : ""}` : ""}>
                <div style={{
                    gridTemplateColumns: `${gridColumns ? gridColumns : `repeat(${isChildItems ? customColumns?.length - 2 : customColumns?.length}, 1fr)`} `
                }} className="accordion-item">

                    {customColumns.map((column) => {
                        return <div className="column-div" style={{ position: column.label ? "relative" : "", display: `${column?.display ? column.display : "inline-block"}` }}>
                            {column.label && <h5 className={`column-title ${titleClass ? titleClass : ""}`} >{customLabel ? customLabel : column.label ? column.label : ""}</h5>}
                            {column.options.customBodyRenderLite ? column.options.customBodyRenderLite(index, data, drag) : ""}
                        </div>
                    })}
                    {isAccordion && !expand ? <KeyboardArrowDown className="expand-icon" onClick={() => {
                        if (from) {
                            callFetch(0, 10)
                        }
                        setExpand(true)
                    }} />
                        : isAccordion ? <KeyboardArrowUp className="expand-icon" onClick={() => setExpand(false)} /> : ""}
                </div>
                {isAccordion && expand &&
                    <div className={`accordion-sub-items-container ${loading ? "min-hei" : ""}`}>
                        {!from && <div className="accordion-header">
                            <h5 className="column-title" >Credentials ({data.length})</h5>
                            <Button onClick={() => quickAddCredential(data[0]?.application_name)} className="add-credential-button">Add {data[0]?.application_name} Credential</Button>
                        </div>}

                        {data.length ? loading ? <CircularProgress className="circular-progress-icon" size={40} />
                            : data.map((item) => {
                                return <NewAccordion
                                    customColumns={customItemColumns}
                                    data={item ? item : []}
                                    showType={showType}
                                    isChildItems={true} />
                            }) : ""}
                        {fetchChildItems && loading ? <CircularProgress className="circular-progress-icon" size={40} />
                            : (childItems?.data?.length ? childItems?.data.map((item) => {
                                return <NewAccordion
                                    customColumns={customItemColumns}
                                    data={item ? item : []}
                                    showType={showType}
                                    gridColumns={childGridColumns ? childGridColumns : "1fr 1fr 1fr 1fr 1fr"}
                                    isChildItems={true}
                                // customLabel={from === "history" && showType === "shortQueue" && item.operation_status ? t(`MESSAGES.MONITORING.${item.operation_status}`) : ""}

                                />
                            }) : <div className='empty-page-info-container p-b-0'>
                                <img src={emptyPageIcon} />
                                <p className='info-text'>{t('MESSAGES.MONITORING.EMPTY-OPERATIONS')}</p>
                            </div>)}
                    </div>}
                {!isChildItems && showType && expand ? <Pagination totalItems={childItems?.count ? childItems.count : 1} callFetch={callFetch} disabled={loading}
                    fetchParentItems={fetchParentItems} showType={showType} expand={expand} triggerFetch={triggerFetch} stopFetch={stopFetch} trigger={trigger} /> : ""}
            </div>
        </>
    )
}

export default NewAccordion;
